import { BonusByProductTableTranslations } from ".";

export const BONUS_BY_PRODUCT_TABLE_EN_US: BonusByProductTableTranslations = {
	title: "Bonus by product",
	filename: "bonus_by_product",
	columns: {
		product: "Product",
		productCategory: "Product Category",
		bonusCategory: "Bonus Category",
		value: "Bonus received during the period",
		bonusSpentFromOtherPeriod: "Bonus received in another period",
		receivedInPeriod: "Received in the event",
		receivedInOtherPeriod: "Received in other events",
		total: "Total of the category",
		noCategory: "No category",
	},
	exportToExcel: "Export to Excel",
};
